/**
 * Token-styled semantic table primitives. The approved design renders the rooms
 * and devices lists as plain tables (two-line cells, status chips, clickable
 * hover rows, a planned column), which these reproduce exactly while colouring
 * everything from Oxygen semantic tokens (so light + dark both work). The chips
 * and controls inside the cells are stock Oxygen components.
 *
 * Roadmap: `@8x8/oxygen-data-table` (built-in sort / pagination / column
 * management) is the upgrade path once a tenant's fleet outgrows a client-side
 * filtered list; today's lists are modest and filtered in-memory.
 */

import styled from 'styled-components';

export const TableEl = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const Th = styled.th<{ $align?: 'left' | 'right' | 'center'; $muted?: boolean }>`
    text-align: ${p => p.$align ?? 'left'};
    padding: 9px 16px;
    font-size: 12px;
    font-weight: 600;
    color: ${p => (p.$muted ? p.theme.textColor05 : p.theme.textColor01)};
    background: ${p => p.theme.ui06};
    border-bottom: 2px solid ${p => p.theme.ui01};
    white-space: nowrap;
`;

export const Td = styled.td<{ $align?: 'left' | 'right' | 'center' }>`
    padding: 13px 16px;
    border-bottom: 1px solid ${p => p.theme.ui01};
    vertical-align: middle;
    text-align: ${p => p.$align ?? 'left'};
    font-size: 13px;
    color: ${p => p.theme.textColor01};
`;

export const ClickRow = styled.tr`
    cursor: pointer;

    &:hover td {
        background: ${p => p.theme.ui02};
    }
`;

export const PrimaryCellText = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${p => p.theme.textColor01};
`;

export const SecondaryCellText = styled.div`
    font-size: 12px;
    color: ${p => p.theme.textColor05};
    font-family: ui-monospace, Menlo, Consolas, monospace;
    margin-top: 2px;
`;

/* Denser table for the in-card devices list. */

export const ThSm = styled.th<{ $align?: 'left' | 'right' | 'center' }>`
    text-align: ${p => p.$align ?? 'left'};
    padding: 6px 8px;
    font-size: 11px;
    font-weight: 600;
    color: ${p => p.theme.textColor05};
    border-bottom: 1px solid ${p => p.theme.ui01};
    white-space: nowrap;
`;

export const TdSm = styled.td<{ $align?: 'left' | 'right' | 'center' }>`
    padding: 10px 8px;
    border-bottom: 1px solid ${p => p.theme.ui02};
    vertical-align: middle;
    text-align: ${p => p.$align ?? 'left'};
    font-size: 13px;
    color: ${p => p.theme.textColor01};
`;
